<template>
  <el-dialog
    title="移动产品分类"
    width="450px"
    :close-on-click-modal="false"
    :visible="visible"
    @update:visible="updateVisible"
    @open="onOpen"
    @close="onClose"
    tabindex="-1"
    @keyup.enter.native="onSubmit()">
    <el-form ref="form"
             :model="form"
             :rules="rules"
             v-loading="loading"
             size="small"
             label-width="70px"
             style="padding-right: 50px;margin-bottom: -20px;">
      <el-form-item label="区域"
                    prop="prod_classid">
        <sj-remote-select v-model="form.prod_classid"
                          :remote-method="getClbProductAreaTable"
                          style="width: 100%;"></sj-remote-select>
      </el-form-item>
      <el-form-item label="分类"
                    prop="prod_categid">
        <sj-remote-select v-model="form.prod_categid"
                          :remote-method="getClbProductCategoryTable"
                          :remote-params="{prod_classid: form.prod_classid}"
                          style="width: 100%;"></sj-remote-select>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="updateVisible(false)">取 消</el-button>
      <el-button type="primary"
                 @click="onSubmit()"
                 :disabled="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { makeRule } from '@utils/rule'

export default {
  components: {},
  mixins: [],
  props: {
    ids: Array,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      loading: false,
      form: {
        prod_classid: null,
        prod_categid: null,
      },
      rules: {
        prod_classid: [
          {...makeRule('请选择任务区域', 'integer'), min: 1},
        ],
        prod_categid: [
          {...makeRule('请选择任务分类', 'integer'), min: 1},
        ],
      },
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    ...request.map(['getClbProductAreaTable', 'getClbProductCategoryTable']),
    updateVisible (value) {
      this.$emit('update:visible', value)
    },
    onOpen () {},
    onClose () {
      this.$refs.form.resetFields()
    },
    onSubmit () {
      this.$refs.form.validate().then(() => {
        this.move(this.ids)
      }).catch(() => {
        this.$message.error('提交内容填写不正确！')
      })
    },
    move (ids) {
      this.loading = true
      request.common('moveClbProductTo', {product_ids: ids, ...this.form}).then((res) => {
        this.$alert('查理任务产品移动成功!', '提示', {type: 'success'}).then(() => {
          this.updateVisible(false)
          this.$message.success('修改成功！')
          this.$emit('success')
        })
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/clb-product/components/ClbProductMoveFormDialog.vue